import type { NonFixedTime } from '../EditEdutainmentModal/types';

const checkIsSameDateAndTimeRangeOverlap = (args: {
  compareFields: NonFixedTime[];
  validatingField: NonFixedTime;
}) => {
  const { compareFields, validatingField } = args;

  const isOverlap = compareFields.some((field) => {
    if (
      !field.date ||
      !field.startTime ||
      !field.endTime ||
      !validatingField.date ||
      !validatingField.startTime ||
      !validatingField.endTime
    ) {
      return false;
    }

    if (field.startTime.isSameOrAfter(field.endTime, 'minute')) {
      return false;
    }

    const isSameDate = field.date.isSame(validatingField.date, 'date');
    if (!isSameDate) {
      return false;
    }

    return (
      field.startTime.isBefore(validatingField.endTime, 'minute') &&
      field.endTime.isAfter(validatingField.startTime, 'minute')
    );
  });

  return isOverlap;
};

export const validateNonFixedTimeRange = (args: {
  promise: Promise<void>;
  nonFixedSchedule: NonFixedTime[] | undefined;
  validatingFieldName: number;
}) => {
  const { promise, nonFixedSchedule, validatingFieldName } = args;

  return promise
    .then(() => {
      const isOverlap = nonFixedSchedule
        ? checkIsSameDateAndTimeRangeOverlap({
            compareFields: nonFixedSchedule.filter(
              (_, index) => index !== validatingFieldName
            ),
            validatingField: nonFixedSchedule[validatingFieldName],
          })
        : false;
      if (isOverlap) {
        return Promise.reject('時間段不可重疊或重複');
      }
      return Promise.resolve();
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
